import { isStreamingUxExperienceM1Enabled } from './streaming-ux-experience-m1-enabled';

/**
 * Quick actions block streaming eligibility check.
 *
 * The M1 streaming UX experiment controls whether quick action edits snap into the
 * document a block at a time rather than character by character.
 */
export const isQuickActionsBlockStreamingEnabled = (): boolean =>
	isStreamingUxExperienceM1Enabled();
